import { useAPIGetAllocationOverview } from 'api/ps/useAPISelectionPS'
import { RegionType } from 'types/region-type'

import { useRegionContext } from 'utils/hooks/useRegion'

interface ParamsCurrentRegionRatioDemandPS {
  regionId?: string
  regionType?: RegionType
}

const useCurrentRegionRatioDemandPS = ({
  regionId,
  regionType,
}: ParamsCurrentRegionRatioDemandPS = {}) => {
  const { regionDetail } = useRegionContext()
  const {
    data: {
      ikg = 0,
      activeCount = 0,
      satdikCount = 0,
      currentRatio = 0,
      suggestedRatio = 0,
      suggestedRatioBeforeIkg = 0,
      calculationDetailResult = 0,
      currentAhliMudaNumber = 0,
      currentAhliMadyaNumber = 0,
      currentAhliUtamaNumber = 0,
      suggestedAhliNumberTotal = 0,
      suggestedAhliMudaNumber = 0,
      suggestedAhliMadyaNumber = 0,
      suggestedAhliUtamaNumber = 0,
    } = {},
    isLoading,
  } = useAPIGetAllocationOverview({
    regionId: regionId || regionDetail.id,
    regionType: regionType || regionDetail.type,
  })

  const isIdealCurrentRatio = activeCount > 0 && suggestedAhliNumberTotal <= 0

  return {
    isLoading,
    ikg,
    calculationDetailResult,
    activeCount,
    satdikCount,
    currentRatio,
    suggestedRatio,
    suggestedRatioBeforeIkg,
    currentAhliMudaNumber,
    currentAhliMadyaNumber,
    currentAhliUtamaNumber,
    suggestedAhliNumberTotal: Math.max(0, suggestedAhliNumberTotal),
    suggestedAhliMudaNumber,
    suggestedAhliMadyaNumber,
    suggestedAhliUtamaNumber,
    isIdealCurrentRatio,
  }
}

export default useCurrentRegionRatioDemandPS
